module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Ancient-Assassins-2.86b1f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Ancient-Assassins-2.jpg
// module id = ds/y
// module chunks = 0